import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { ConfigState } from "../models/ConfigState";

const setError = (state: ConfigState, action: PayloadAction<Error>) => {
    state.isLoading = false;
    state.isError = action.payload.error;
}

export default setError;